import { isDisplayMediaTrack } from '@/entities/media-devices'
import { useWebRTC } from '@/entities/webrtc'

import { isBackgroundBlurProcessedStream } from './maybe-apply-background-blur'
import { requestKeyframeAfterReplace } from './request-keyframe-after-replace'

/**
 * Ask every live local webcam sender for a keyframe (SFU late-joiner / after blur replace).
 */
export const requestKeyframesOnActiveLocalWebcams = async (): Promise<void> => {
  const { sessions } = useWebRTC()

  for (const sessionFacade of sessions.value.values()) {
    const connection = sessionFacade.session.connection as RTCPeerConnection | undefined
    if (!connection || connection.connectionState === 'closed') continue

    const localStream = sessionFacade.localVideoStream.value
    const localTrack = localStream?.getVideoTracks()[0]
    const allowEnabledNudge = !localStream || !isBackgroundBlurProcessedStream(localStream)

    for (const sender of connection.getSenders()) {
      const track = sender.track
      if (!track || track.kind !== 'video' || track.readyState !== 'live') continue
      if (isDisplayMediaTrack(track)) continue

      // Prefer the current local webcam sender; skip unrelated video m-lines when possible.
      if (localTrack && track.id !== localTrack.id) {
        const hasExactLocalSender = connection.getSenders().some((other) => (
          other !== sender
          && other.track?.id === localTrack.id
        ))
        if (hasExactLocalSender) continue
      }

      await requestKeyframeAfterReplace(sender, {
        allowEnabledNudge,
        retryMs: 250,
      })
    }
  }
}
